// extracted by mini-css-extract-plugin
export default {"box":"Home_box__dBNXy","nav":"Home_nav__3iNFi"};